import React, {useState} from "react";
import {TaskImageType, TaskImageTypeTranslationId, TaskType} from "../types/Task";
import i18n from "../lang/i18n";
import {mdiChevronRightCircle} from "@mdi/js";
import Icon from "@mdi/react";
import AddressTaskImageActionButton from "./AddressTaskImageActionButton";
import {useManageContext} from "../App";
import {canBeDelivered} from "../Helper";
import {FieldRequireType} from "../types/General";
import {useNavigate} from 'react-router-dom';

// eslint-disable-next-line import/no-anonymous-default-export
export default ({Task}: { Task: TaskType }) => {

    const {trip} = useManageContext();
    const taskCanBeDelivered = trip && canBeDelivered(Task, trip);
    const [missingDocs, setMissingDocs] = useState<TaskImageType[]>([]);
    const navigate = useNavigate();
    const [uploadedImages, setUploadedImages] = useState({
        CMR: false,
        TEMP: false,
        PLL: false,
        IMAGE: false,
    });

    if (!trip) {
        return null;
    }

    const onSuccess = async (type: TaskImageType) => {
        setUploadedImages(prev => ({
            ...prev,
            [type]: true,
        }));
    }

    const getMissingDocs = () => {
        let missingDocs = [];

        if (Task.CmrRequiredType === FieldRequireType.Required && (Task.CmrUploadedCount === 0 && !uploadedImages.CMR)) {
            missingDocs.push(TaskImageType.CMR);
        }
        if (Task.TempMeasurementRequiredType === FieldRequireType.Required && Task.TempMeasurementUploadedCount === 0 && !uploadedImages.TEMP) {
            missingDocs.push(TaskImageType.TEMP);
        }
        if (Task.PllExchangeCmrRequiredType === FieldRequireType.Required && Task.PllExchangeCmrUploadedCount === 0 && !uploadedImages.PLL) {
            missingDocs.push(TaskImageType.PLL);
        }

        return missingDocs;
    }

    const getOptionalMissingDocs = () => {
        let missingOptionalDocs = [];

        if (Task.CmrRequiredType === FieldRequireType.Optional && Task.CmrUploadedCount === 0 && !uploadedImages.CMR) {
            missingOptionalDocs.push(TaskImageType.CMR);
        }
        if (Task.TempMeasurementRequiredType === FieldRequireType.Optional && Task.TempMeasurementUploadedCount === 0 && !uploadedImages.CMR) {
            missingOptionalDocs.push(TaskImageType.TEMP);
        }
        if (Task.PllExchangeCmrRequiredType === FieldRequireType.Optional && Task.PllExchangeCmrUploadedCount === 0 && !uploadedImages.CMR) {
            missingOptionalDocs.push(TaskImageType.PLL);
        }

        return missingOptionalDocs;
    }

    const completeTask = () => {
        // Task can be completed
        if (!taskCanBeDelivered) {
            alert(i18n.t('2597'));

            return;
        }

        // Handle required missing docs
        const missingDocs = getMissingDocs();
        if (missingDocs.length > 0) {
            setMissingDocs(missingDocs);

            // @ts-ignore
            const documentTranslated = missingDocs.map((docType: string) => i18n.t(TaskImageTypeTranslationId[docType]));

            alert(i18n.t('2576') + ': ' + documentTranslated.join(', ') + '.');

            return;
        }

        // Handle optional missing docs
        const missingOptionalDocs = getOptionalMissingDocs();
        if (missingOptionalDocs.length > 0) {
            setMissingDocs(missingOptionalDocs);

            if (!window.confirm(i18n.t('2601') + ' ' + missingOptionalDocs.join(', ') + '.')) {
                return;
            }
        }

        return navigate('/confirm-delivery-form/' + trip.TripKey + '/' + Task.TaskId);
    }

    return (
        <div className="w-100">
            <div className="p-2 bg-primary mb-4"></div>
            <div className="px-4">
                <div className="d-flex w-100 justify-content-between">
                    {Task.OrderNo !== '' && <div>
                        <h5>{i18n.t('590')}: <span className="fw-light">{Task.OrderNo}</span></h5>
                    </div>}
                    {Task.OrderReference !== '' && <div>
                        <h4># {Task.OrderReference}</h4>
                    </div>}
                </div>
                {(Task.OrderNo !== '' || Task.OrderReference !== '') ? <hr/> : <hr/>}

                {Task.Sender !== '' && <div className="mb-3">
                    <h6 className="mb-2"><span className="text-primary text-uppercase">{i18n.t('183')}</span></h6>
                    <h5 className="fw-light">{Task.Sender}</h5>
                </div>}

                {Task.FirstLoadingAddress !== '' &&
                    <h6 className="fw-light">{Task.FirstLoadingAddress}</h6>}

                {Task.LoadingReference !== '' &&
                    <h6 className="mb-0"><span className="fw-bold">{i18n.t('418')}:</span> {Task.LoadingReference}</h6>}

                {Task.Sender !== '' && <hr/>}

                {Task.Consignee !== '' && <div className="mb-3">
                    <h6 className="mb-2"><span className="text-primary text-uppercase">{i18n.t('2381')}</span></h6>
                    <h5 className="fw-light">{Task.Consignee}</h5>
                </div>}

                {Task.LastDeliveryAddress !== '' &&
                    <h6 className="fw-light">{Task.LastDeliveryAddress}</h6>}

                {Task.DeliveryReference !== '' &&
                    <h6 className="mb-0"><span className="fw-bold">{i18n.t('2078')}:</span> {Task.DeliveryReference}
                    </h6>}

                {Task.CargoDescriptionHtml !== '' && <div>
                    <hr className="mb-0"/>
                    <div dangerouslySetInnerHTML={{__html: Task.CargoDescriptionHtml}}></div>
                </div>}

                <div className="row mt-5 justify-content-between">
                    {Task.AddCmrIsVisible && <div className="col">
                        <AddressTaskImageActionButton
                            text={i18n.t('2592')}
                            section={Task.FileUploadFolderName}
                            number={Task.FileUploadSubFolderName}
                            filename={Task.CmrFileName}
                            tripKey={trip.TripKey}
                            onSuccess={onSuccess}
                            taskKey={Task.TaskId}
                            fileType={TaskImageType.CMR}
                            bgClass={Task.CmrUploadedCount || uploadedImages.CMR
                                ? 'bg-success'
                                : (missingDocs.includes(TaskImageType.CMR)
                                        ? 'bg-danger'
                                        : 'bg-primary-container'
                                )
                            }
                        />
                    </div>}

                    {Task.AddTempMeasurementIsVisible && <div className="col">
                        <AddressTaskImageActionButton
                            text={i18n.t('2602')}
                            section={Task.FileUploadFolderName}
                            number={Task.FileUploadSubFolderName}
                            filename={Task.TempMeasurementFileName}
                            tripKey={trip.TripKey}
                            taskKey={Task.TaskId}
                            onSuccess={onSuccess}
                            fileType={TaskImageType.TEMP}
                            bgClass={Task.TempMeasurementUploadedCount || uploadedImages.TEMP
                                ? 'bg-success'
                                : (missingDocs.includes(TaskImageType.TEMP)
                                        ? 'bg-danger'
                                        : 'bg-primary-container'
                                )
                            }
                        />
                    </div>}

                    {Task.AddPllExchangeCmrIsVisible && <div className="col">
                        <AddressTaskImageActionButton
                            text={i18n.t('2594')}
                            section={Task.FileUploadFolderName}
                            number={Task.FileUploadSubFolderName}
                            filename={Task.FileUploadSubFolderName}
                            tripKey={trip.TripKey}
                            taskKey={Task.TaskId}
                            onSuccess={onSuccess}
                            fileType={TaskImageType.PLL}
                            bgClass={Task.PllExchangeCmrUploadedCount || uploadedImages.PLL
                                ? 'bg-success'
                                : (missingDocs.includes(TaskImageType.PLL)
                                        ? 'bg-danger'
                                        : 'bg-primary-container'
                                )
                            }
                        />
                    </div>}

                    {Task.AddPhotoIsVisible && <div className="col">
                        <AddressTaskImageActionButton
                            text={i18n.t('2593')}
                            section={Task.FileUploadFolderName}
                            number={Task.FileUploadSubFolderName}
                            filename={Task.PhotoFileName}
                            tripKey={trip.TripKey}
                            taskKey={Task.TaskId}
                            onSuccess={onSuccess}
                            fileType={TaskImageType.IMAGE}
                            bgClass={Task.PhotoUploadedCount || uploadedImages.IMAGE
                                ? 'bg-success'
                                : (missingDocs.includes(TaskImageType.IMAGE)
                                        ? 'bg-danger'
                                        : 'bg-primary-container'
                                )
                            }
                        />
                    </div>}

                </div>

                <button onClick={completeTask} className="btn btn-primary w-100 mt-3 mb-3 py-3 fw-light">
                    <Icon className="me-2" path={mdiChevronRightCircle}
                          size={1}/>{i18n.t(String(Task.TaskCompletedButtonTranslationId))}
                </button>
            </div>
        </div>
    );
}